import React, { useState, useEffect, useRef, Fragment } from "react";
import { Button, Header, Icon, Image, Modal } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import { setPopupRecords } from "../../store/action/ediReqRecords";
import { setFlagforPopup } from "../../store/action/ediReqRecords";
import { clearRecordCreatedPopup } from "../../store/action/createRecord";
function EditRequest(props) {
  const [open, setOpen] = useState(false);
  const [dimmer, setDimmer] = useState(undefined);
  const [fields, setFields] = useState([{ record: null }]);
  const [ind, setCurrentind] = useState(0);
  const country = useSelector((state) => window.shipmentCountry || state.isf?.currentJobData.shipment.countryOfBusiness || props.countryOfBusiness);

  const [currentLength, setCurrentLength] = useState();
  const dispatch = useDispatch();
  const [disableValue, setdisableValue] = useState(0);
  const [disableminValue, setdisableminValue] = useState(0);
  const PopupRecords = useSelector((state) => state.ediReq?.popupRecords);
  const PopupShow = useSelector((state) => state.ediReq.popUpShow);
  const eventType = useSelector((state) => state.edi.edidata?.eventType);
  const UsaRecords = useSelector((state) => state.ediReq.ediReqRecords?.eventMessage?.ediTxnRequest);

  const CbsaRecords = useSelector((state) => state.ediReq.ediReqRecords?.eventMessage?.cbsaTxnRequest);

  const getRecords = () => {
    if (eventType === "GET_CBSA_REQUEST_MESSAGE") {
      return CbsaRecords ? CbsaRecords[0].records : [];
    }
    return UsaRecords ? UsaRecords[0].records : [];
  };

  let recdata = PopupShow ? PopupRecords : getRecords();

  const handleChange = (i, event) => {
    const values = [...fields];
    values[i].record = event.target.value;
    setFields(values);
    lengthcheck(values);
  };

  const handleRemove = async (i) => {
    const values = await [...fields];
    await values.splice(i, 1);
    await setFields(values);
    await setCurrentind(i - 1);
    lengthcheck(values);

    document.getElementById(`${i - 1}`) && document.getElementById(`${i - 1}`).focus();
    
    if(country==='CA'){
      let x = values[values.length-4].record.includes("UNT") ? values[values.length-4].record : values[values.length-3].record



      let untSegment = x.substring(x.indexOf("UNT+")+4,x.indexOf("MREF")-1)
      let y  = x.replace(untSegment,parseInt(untSegment)-1)


      values.splice(values.length-3,1,{record : y}) 

    }
  };
  const openModal = () => {
    setOpen(true);
    setDimmer("blurring");
  };

  const lengthcheck = async (values) => {
    let arr = [];
    let field = values ? [...values] : fields;

    for (let i = 0; i < field.length; i++) {
      if (field[i]?.record) {
        arr.push(field[i]?.record.length + 1);
      } else {
        arr.push(1);
      }
    }

    setdisableValue(Math.max(...arr));
    setdisableminValue(Math.min(...arr) - 1);

    return arr;
  };
  useEffect(() => {
    let fieldData = [];

    let requestData = recdata.recordlist;

    if (requestData) {
      for (let i = 0; i <= requestData.length; i++) {
        if (requestData[i]) {
          fieldData.push({ record: requestData[i].record });
        }
      }
      setFields(fieldData);
      setCurrentind(fieldData.length - 1);
    }
  }, []);

  const handleAdd = async () => {
    let values = await [...fields];
    await values.splice(ind + 1, 0, { record: null });
    await setFields(values);
    document.getElementById(`${ind + 1}`) && document.getElementById(`${ind + 1}`).focus();
    lengthcheck(values);

    if(country==='CA'){
      let x = values[values.length-4].record.includes("UNT") ? values[values.length-4].record : values[values.length-3].record

      let untSegment = x.substring(x.indexOf("UNT+")+4,x.indexOf("MREF")-1)
      let y  = x.replace(untSegment,parseInt(untSegment)+1)

      values.splice(values.length-3,1,{record : y}) 
    }
  };
  const onPaste = async (e) => {
    let clipboardData, pastedData, currentFocussedRow;

    // Get pasted data via clipboard API
    clipboardData = e.clipboardData || window.clipboardData;
    currentFocussedRow = e.target;
    let copiedText = clipboardData.getData("Text").replace(/(\r\n|\n|\r)/gm, "");
    if (copiedText.length > 80) {
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();
      pastedData = copiedText.replace(/\]\[/g, "%%");
      let EdiData = pastedData.substr(1, pastedData.length - 2).split("%%");

      let currentRowIndex = ind;

      const newRecord = [...fields];

      let afterSplice = newRecord.splice(currentRowIndex);

      EdiData.forEach(function (item) {
        newRecord.push({ record: item });
      });

      let NewRecordArray = [...newRecord, ...afterSplice];
      let recordArrayAfterFiltering = NewRecordArray.filter((newArray) => newArray.record);

      await setFields(recordArrayAfterFiltering);
      lengthcheck(recordArrayAfterFiltering);
    }
  };

  return (
    <Fragment id="edi-ui-ediReq">
      <Modal
        className='edi-ui'
        onClose={() => setOpen(false)}
        onOpen={openModal}
        dimmer={dimmer}
        open={open}
        trigger={
          <Tooltip title="Edit Records" placement="top" arrow aria-label="Edit Records">
            <button className="edit-button">Edit EDI</button>
          </Tooltip>
        }
      >
        <Modal.Header>
          {" "}
          <div>
            {currentLength ? currentLength : "0"}
            /80
            <h3
              style={{
                textAlign: "center",
                display: "inline-block",
                width: "80%"
              }}
            >
              ADD/UPDATE RECORD{" "}
            </h3>
            <Icon style={{ cursor: "pointer", float: "right" }} onClick={handleAdd} name="add circle" />
          </div>
        </Modal.Header>
        <Modal.Content scrolling style={{"width":"100%"}}>
          <Modal.Description>
            <div style={fields && fields.length > 10 ? { height: "500px", overflow: "scroll" } : {}}>
              {fields &&
                fields.map((field, idx) => {
                  return (
                    <div key={`${field}-${idx}`}>
                      <input
                        value={field.record || ""}
                        type="text"
                        id={`${idx}`}
                        placeholder="Enter Record"
                        onChange={(e) => {
                          setCurrentLength(e.target.selectionStart);
                          handleChange(idx, e);
                          lengthcheck();
                        }}
                        onPaste={onPaste}
                        className="inputStyle"
                        onFocus={(e) => {
                          setCurrentind(idx);
                          setCurrentLength(e.target.selectionStart);
                        }}
                        onClick={(e) => setCurrentLength(e.target.selectionStart)}
                        onKeyUp={(e) => setCurrentLength(e.target.selectionStart)}
                      />{" "}
                      {""}
                      {fields.length > 1 ? <Icon style={{ cursor: "pointer" }} onClick={() => handleRemove(idx)} name="trash alternate" /> : ""}
                      {country === "US" && field.record?.length !== 80 && (
                        <span
                          style={{
                            color: "red",
                            display: "block",
                            fontFamily: "Inconsolata",
                          }}
                        >
                          Length of this record should be 80{" "}
                        </span>
                      )}
                    </div>
                  );
                })}
            </div>
          </Modal.Description>
        </Modal.Content>
        <Button color="red" onClick={handleAdd}>
          New Row
        </Button>
        <Modal.Actions>
          <Button color="red" onClick={() => setOpen(false)}>
            Don't Add Record
          </Button>
          <Button
            content="Yes, Add Record"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setOpen(false);
              dispatch(setPopupRecords(fields));
              dispatch(setFlagforPopup(true));
              dispatch(clearRecordCreatedPopup());
            }}
            positive
            disabled={country === "US" && (disableValue > 81 || disableminValue < 80) ? true : disableminValue < 1 ? true : false}
          />
        </Modal.Actions>
      </Modal>
    </Fragment>
  );
}

export default EditRequest;
